<template>
  <modal :modal-key="'celebrity-process-expired'" :class-style="'modal--welcomeback'"
         :body-style="'bonus_content'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_celebrity_game_over }}</h1>
      <br>
      <img class="pinicon" :src="getTranslations.project_celebrity_img" alt="">
    </template>
    <template slot="body">
      <p>{{ getTranslations.home_modals_celebrity_active_again }}</p>
    </template>
    <template slot="footer">
      <div @click.prevent="closeMethod">
        <a class="btn2 btn2_modal btn2--std btn2--small" style="cursor:pointer">{{
          getTranslations.home_modals_celebrity_close }}</a></div>
    </template>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  // modal_declined_request.html
  name: 'celebrity-process-expired',
  components: {
    Modal,
  },
  methods: {
    closeMethod() {
      this.$emit('close');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/challenge/CelebrityProcessExpired.vue